import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils.js';

export function Skeleton({
  className,
  ...props
}: ComponentProps<'div'>): React.ReactNode {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        'rounded-md bg-muted animate-pulse-soft relative overflow-hidden',
        'after:absolute after:inset-0 after:-translate-x-full after:animate-shimmer',
        'after:bg-gradient-to-r after:from-transparent after:via-foreground/5 after:to-transparent',
        className,
      )}
      {...props}
    />
  );
}
